import { ApiService, ApiRequestConfig, ApiError } from '@libs-uuif/shared/api-service';
import { currentUserKey } from '@/shared/msw-constants';
import MSWHttpInterceptor from './http-interceptor';
import { AppStore } from '@/store';
import VueRouter from 'vue-router';
import { envCongif } from '@/shared/env.config';

class ApiServiceWrapper {
  apiService: ApiService;
  baseUrl = `${envCongif.apiGatewayHostUrl}/`;
  token: string = '';
  $store: AppStore;
  $route: VueRouter;
  init(router: VueRouter,  store: AppStore) {
    this.$store = store;
    this.$route = router;
  }
  constructor() {
    this.apiService = new ApiService(this.baseUrl);
  }
  getConfig(data: any = {}) {
    const apiRequestConfig: ApiRequestConfig = {
      data,
      timeout: 300000,
      requestType: 'json',
      responseType: 'json',
      headers: { },
    };
    const currentUser = localStorage.getItem(currentUserKey);
    const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
    if (token) {
      apiRequestConfig.headers = { Authorization: `Bearer ${token}` };
    }
    return apiRequestConfig;
  }

  get<R>(endpoint: string): Promise<R> | any {
    return this.apiService.get(this.makeUrlLowerCase(endpoint), this.getConfig())
    .catch((error: ApiError) => {
      MSWHttpInterceptor.handleError(error);
      throw MSWHttpInterceptor.modifyErrorMessage(error);
    });
  }
  post<R>(endpoint: string, data: any = {}): Promise<R> | any {
    return this.apiService.post(this.makeUrlLowerCase(endpoint), data, this.getConfig())
    .catch((error: ApiError) => {
      MSWHttpInterceptor.handleError(error);
      throw MSWHttpInterceptor.modifyErrorMessage(error);
    });
  }
  put<R>(endpoint: string, data: any = {}): Promise<R> | any {
    return this.apiService.put(this.makeUrlLowerCase(endpoint), data, this.getConfig())
    .catch((error: ApiError) => {
      MSWHttpInterceptor.handleError(error);
      throw MSWHttpInterceptor.modifyErrorMessage(error);
    });
  }
  delete<R>(endpoint: string, data?: any): Promise<R> | any {
    return this.apiService.delete(this.makeUrlLowerCase(endpoint), this.getConfig(data))
    .catch((error: ApiError) => {
      MSWHttpInterceptor.handleError(error);
      throw MSWHttpInterceptor.modifyErrorMessage(error);
    });
  }
  patch<R>(endpoint: string, data: any = {}): Promise<R> | any {
    return this.apiService.patch(this.makeUrlLowerCase(endpoint), data, this.getConfig())
    .catch((error: ApiError) => {
      MSWHttpInterceptor.handleError(error);
      throw MSWHttpInterceptor.modifyErrorMessage(error);
    });
  }

  replaceTiltPipe(endpoint: string) {
    window.location.replace(`${this.baseUrl}${endpoint}`);
  }

  setAuth(authParam: any) {
    return this.apiService.setAuth(authParam);
  }

  makeUrlLowerCase(url: any) {
    // If url has query params then all keys will be lowercased
    if (url.indexOf('?') > -1) {
      const index = url.indexOf('?');
      const endpoint = url.substr(0, index)
      .toLowerCase();
      const params = url.substr(index, url.length)
      .replace('?', '&');

      let startLowerCasing = false;
      let final = '';

      for (let i = 0; i < params.length ; i = i + 1) {
        if (params.charAt(i) === '&') {
          startLowerCasing = true;
        }

        if (params.charAt(i) === '=') {
          startLowerCasing = false;
        }

        if (startLowerCasing) {
          final = final + params.charAt(i)
          .toLowerCase();
        } else {
          final = final + params.charAt(i);
        }
      }
      return endpoint.concat('?')
      .concat(final.substring(1));
    }
    // If it has no query params then simply lowercase it
    return url.toLowerCase();
  }
}

export default new ApiServiceWrapper();
